import { css, cva } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const wrapperClass = css({
	width: "full",
});

export const headerClass = flex({
	justifyContent: "space-between",
	flex: "[0 0 auto]",
	width: "full",
	padding: "8",
	paddingLeft: "0",
});

export const activeGlobalDiscountWrapperClass = flex({
	alignItems: "center",
});

export const activeGlobalDiscountCodeClass = flex({
	alignItems: "center",
	gap: "4",
});

export const globalDiscountStatusBadgeClass = cva({
	base: {
		display: "inline-flex",
		alignItems: "center",
		borderRadius: "8",
		paddingX: "8",
		paddingY: "2",
		border: "1px solid",
		fontWeight: "bold",
	},
	variants: {
		status: {
			SCHEDULED: {
				backgroundColor: "warning.0",
				borderColor: "warning.20",
			},
			ACTIVE: {
				backgroundColor: "success.0",
				borderColor: "success.20",
			},
			NONE: {
				backgroundColor: "shade.5",
				borderColor: "shade.20",
			},
		},
	},
});

export const globalDiscountStartDateFieldClass = css({
	marginBottom: "8",
});
